import * as Sentry from "@sentry/browser";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { apiClient } from "@/api/apiClient";
import { API_PATHS } from "@/constants";
import FullScreenLoader from "@/components/FullScreenLoader";
import { useLoadQuizBlocks } from "@/hooks/useLoadQuizBlocks";
import { QuizContextProvider } from "@/pages/quiz/context";
import { QuizV1 } from "@/pages/quiz/base";
import { CheckInWelcomeScreen } from "@/pages/voucher/components/CheckInWelcomeScreen";

interface IProps {
  isCheckIn?: boolean;
}
const VoucherPageNew = ({ isCheckIn }: IProps) => {
  const { voucherId } = useParams();
  const [searchParams] = useSearchParams();
  const [hasClickedStart, setHasClickedStart] = useState(false);

  const monthlyCheckInId = searchParams.get("monthly_check_in_id");
  const channel = searchParams.get("channel");
  const day = searchParams.get("day");

  // Handles old check-in links.
  const apiTemplateCb = isCheckIn
    ? monthlyCheckInId
      ? API_PATHS.CHECK_IN_BLOCKS
      : API_PATHS.DEPRECATED_CHECK_IN_BLOCKS
    : API_PATHS.FORM_BLOCKS;

  const { loading, quizBlocks, errorMessage } = useLoadQuizBlocks(
    apiTemplateCb((monthlyCheckInId ? monthlyCheckInId : voucherId) ?? "")
  );

  useEffect(() => {
    if (!monthlyCheckInId || !channel || !day) return;

    const openEvent = async () => {
      try {
        await apiClient.post(API_PATHS.CHECK_IN_OPEN_EVENT(monthlyCheckInId), {
          channel,
          day,
        });
      } catch (error) {
        console.error(error);
        Sentry.captureException(error);
      }
    };

    openEvent();
  }, [channel, day, monthlyCheckInId]);

  let QuizComponent = QuizV1;

  if (loading || !voucherId) {
    return <FullScreenLoader isLoading={loading} />;
  }

  const hasAnyAnsweredQuestion =
    quizBlocks?.some((block) => block.is_answered) ?? false;
  const showCheckInWelcomeScreen =
    isCheckIn &&
    !hasClickedStart &&
    !hasAnyAnsweredQuestion &&
    !errorMessage &&
    !!quizBlocks?.length;

  if (showCheckInWelcomeScreen) {
    return <CheckInWelcomeScreen onStart={() => setHasClickedStart(true)} />;
  }

  return (
    <QuizContextProvider
      questions={quizBlocks}
      voucherId={voucherId}
      monthlyCheckInId={monthlyCheckInId}
      loadQuizBlocksErrorMessage={errorMessage}
    >
      <QuizComponent isHideProgressBackButton={!!monthlyCheckInId}/>
    </QuizContextProvider>
  );
};

export default VoucherPageNew;
